import { Vue, Component } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import * as LANGUAGES from '@/@next/store/languages/types'

import { Language } from '@/shared/languages'

@Component({})
export default class Translatable extends Vue {
  @Getter(LANGUAGES.GET_ALL)
  getLanguages!: Language[]
  @Getter(LANGUAGES.GET_CURRENT)
  getCurrentLanguage!: Language
  @Getter(LANGUAGES.GET_DEFAULT)
  getDefaultLanguage!: string

  // @Action(LANGUAGES.SET_SELECTED)
  // setSelectedLanguage!: (iso: string) => void
}
